export const SMALL_SIZE = 'SMALL_SIZE';
export const BIG_SIZE = 'BIG_SIZE';
